/** Internal dependencies */
import { apiCall } from './apiCall';
import { getCurrentFilters } from './getCurrentFilters';
import { resetPagination } from './resetPagination';

/**
 * Set up event listeners for our search filter inputs.
 *
 * @param {HTMLElement} searchFilter
 */
export function prepareSearch(searchFilter) {
    // check for change events on the input and click events on the submit button
    const searchInput = searchFilter.querySelector('input[type="search"]');
    const searchSubmit = searchFilter.querySelector('[data-ct-filter-search-submit]');

    if (searchInput) {
        searchInput.addEventListener('keyup', handleSearchInput);
    }

    if (searchSubmit) {
        searchSubmit.addEventListener('click', handleSearchSubmit);
    }
}

/**
 * Handles keyboard input of our search filters.
 *
 * @param {Event} e
 */
function handleSearchInput(e) {
    const input = e.target;

    if (input.value === '' || input.value.length >= 3) {
        const parent = input.closest('[data-ct-rest]');
        resetPagination(parent);
        const currentFilters = getCurrentFilters(parent);
        apiCall(parent, currentFilters, true);
    }
}

/**
 * Handle search filter submit button click
 *
 * @param {Event} e
 */
function handleSearchSubmit(e) {
    e.preventDefault();
    const parent = e.target.closest('[data-ct-rest]');
    resetPagination(parent);
    const currentFilters = getCurrentFilters(parent);
    apiCall(parent, currentFilters, true);
}
